import { TTAPI } from '@/services/TimeTrexClientAPI';
import { BaseViewController } from '@/views/BaseViewController';

export class MyJobApplicationViewController extends BaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {
			el: '#my_job_application_view',
			events: {
				'click #available_jobs': 'availableJobsClick',
			}
		} );

		super( options );
	}

	initialize( options ) {
		super.initialize( options );

		this.viewId = 'MyJobApplication';
		this.api = TTAPI.APIJobApplicantPortal;
		this.$( '.search-result .content' ).empty();
		this.search();
	}

	availableJobsClick() {
		window.location = Global.getBaseURL( null, true, true ).replace(/#!m=.*?(&|$)/g, '#!m=PortalJobVacancy$1'); //Be sure to include any other URL args.
		LocalCacheData.setAllURLArgs( {} );
	}

	getFilterColumnsFromDisplayColumns() {
		var column_filter = {};
		column_filter.id = true;
		column_filter.job_vacancy = true;
		column_filter.job_vacancy_id = true;
		column_filter.interview_date = true;
		column_filter.created_date = true;

		return column_filter;
	}

	search( page_action, page_number, callBack ) {
		var $this = this;
		var filter = {};
		// this.addSearchResultPanel();
		this.vacancy_list_panel = this.$( '.search-result .content' );
		this.more_btn = this.$( '.search-result .more' );
		this.more_btn.unbind( 'click' ).bind( 'click', function() {
			$this.loadMore();
		} );
		filter.filter_data = {};
		filter.filter_sort = {};
		filter.filter_columns = this.getFilterColumnsFromDisplayColumns();
		filter.filter_items_per_page = 0; // Default to 0 to load user preference defined
		if ( this.pager_data ) {
			if ( page_action === 'next' ) {
				filter.filter_page = this.pager_data.next_page;
			} else {
				filter.filter_page = 1;
			}
		} else {
			filter.filter_page = 1;
		}
		this.api['getJobApplication']( filter, false, { // paging or none
			onResult: function( result ) {
				var result_data = result.getResult();
				// if ( !$this.pager_data ) {
				// 	$this.vacancy_list_panel.empty();
				// }
				if ( !Global.isArray( result_data ) ) {
					var no_result_span = $( '<span class="vacancy-list-no-result">' + $.i18n._( 'No Results Found' ) + '</span>' );
					$this.vacancy_list_panel.append( no_result_span );
					$this.vacancy_list_panel.css( 'text-align', 'center' );
					$this.more_btn.hide();
				} else {
					for ( var i = 0; i < result_data.length; i++ ) {
						var row_data = result_data[i];
						var row_template = Global.loadWidget( 'views/portal/hr/my_jobapplication/MyJobApplicationRow.html' );
						var args = {
							job_vacancy: $.i18n._( row_data['job_vacancy'] ),
							created_date: $.i18n._( row_data['created_date'] )
						};
						row_template = $( _.template( row_template )( args ) );
						var url = Global.getBaseURL( null, true, true ).replace(/#!m=.*?(&|$)/g, '#!m=PortalJobVacancyDetail&id=' + row_data['job_vacancy_id'] + '$1'); //Be sure to include any other URL args.
						$( row_template ).find( '.row-vacancy-title > span > a' ).attr( 'href', url );
						$this.vacancy_list_panel.append( row_template );
					}
					$this.pager_data = result.getPagerData();

					if ( $this.pager_data.is_last_page ) {
						$this.more_btn.hide();
					} else {
						$this.more_btn.show();
					}
				}
			}
		} );
	}

	loadMore() {
		this.search( 'next' );
	}
}

MyJobApplicationViewController.html_template = `
<div id="my_job_application_view">
	<div class="job-applicant-navbar">
		<div class="container">
			<div class="row">
				<div class="col-md-3 col-sm-12 col-xs-12">
					<button id="available_jobs" class="btn btn-block btn-default w-100"><span class="glyphicon glyphicon-menu-left"></span> <%= $.i18n._('Available Jobs') %></button>
				</div>
			</div>
		</div>
	</div>
	<div class="search-result">
		<div class="content container">
		</div>
		<div class="more container">
			<div class="row">
				<button type="button" class="btn btn-primary btn-lg btn-block"><%= $.i18n._('Loading') %>...</button>
			</div>
		</div>
	</div>
</div>
`;
